export default "__VITE_ASSET__DH3rc7RJ__"